import React from 'react';
import LocationTemplate from './LocationTemplate';

const RobersonvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Robersonville"
      stateName="North Carolina"
      countyName="Martin"
      zipCodes={["27871"]}
      latitude={35.8243}
      longitude={-77.2509}
      population={1488}
      historicalFact="Named after Henry Roberson, a local landowner who donated land for the railroad."
      nearbyTowns={[
        "Williamston, NC",
        "Hamilton, NC",
        "Oak City, NC",
        "Scotland Neck, NC",
        "Hobgood, NC",
        "Washington, NC",
        "Greenville, NC",
        "Hassell, NC"
      ]}
    />
  );
};

export default RobersonvillePage;